<template>
    <v-overlay :value="i_is_loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>
<script>
export default {
    props:{
        is_loading: Boolean
    },
    data(){
        return {
            id_timeout:null,
            max_loading_timeout: 20000,
            i_is_loading: false
        }
    },
    watch:{
        /**
         * Controlamos aqui o máximo de tempo que é necessário para o loading continuar rodando
         */
        is_loading:function (){
            
            this.i_is_loading = this.is_loading;

            if(this.id_timeout!=null){
                clearTimeout(this.id_timeout);
            }

            if(this.i_is_loading === true){
                
                //definimos um timeout máximo
                this.id_timeout = setTimeout( ()=>{
                    this.i_is_loading = false;
                    this.id_timeout = null;
                }, this.max_loading_timeout)
            }
            else{
                this.i_is_loading = false;
            }

           
        }
    }
}
</script>